export let MessageOverrideKey;

(function (MessageOverrideKey) {
  MessageOverrideKey["ExampleOverride"] = "ExampleOverride";
  MessageOverrideKey["Elevate"] = "elevate";
  MessageOverrideKey["StrategicPartner"] = "strategic-partner";
})(MessageOverrideKey || (MessageOverrideKey = {}));